module.exports = __webpack_public_path__ + "static/award6-22c0de252ad9885b16057ad98d099fc1.png";